import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import s from './Title.module.less';

const Separator = ({
  pipe = false,
  alwaysShow = false,
}: {
  pipe?: boolean;
  alwaysShow?: boolean;
}) => (
  <span className={cn(s.separator, pipe && s.pipeSeparator, alwaysShow && s.show)}>
    {pipe ? '|' : '-'}
  </span>
);

// tells us which labels should have preview styling
type PreviewStatus = {
  addressLine1?: boolean;
  addressLine2?: boolean;
  addressLine3?: boolean;
  cityState?: boolean;
  submarket?: boolean;
};

type Props = {
  displayAddress: string | null;
  listingName: string | null;
  primaryName: string | null;
  cityLocalityRegion: string | null;
  neighborhood: string | null;
  countryCode: string | null;
  directionsButton?: any;
  isPreview?: boolean;
  previewStatus?: PreviewStatus | null;
};

const Title = ({
  displayAddress,
  listingName,
  primaryName,
  cityLocalityRegion,
  countryCode,
  neighborhood = null,
  directionsButton = null,
  isPreview = false,
  previewStatus = {},
}: Props) => {
  const { t } = useTranslation('tourbook');

  return (
    <div className={s.container}>
      {isPreview && <div className={s.preview}>{t('preview')}</div>}
      <div className={s.titleAndDirections}>
        {directionsButton}
        <h3 className={cn(s.titleText, previewStatus?.addressLine1 ? s.primaryNamePreview : '')}>
          {primaryName}
        </h3>
      </div>
      <div className={s.secondaryInformation}>
        <p className={cn(previewStatus?.addressLine2 ? s.listingNamePreview : '')}>
          <b>{displayAddress}</b>
        </p>

        {listingName && (
          <p className={cn(previewStatus?.addressLine3 ? s.listingNamePreview : '')}>
            {listingName}
          </p>
        )}
        <p>
          {neighborhood && (
            <>
              <span className={cn(previewStatus?.submarket ? s.cityStatePreview : '')}>
                {neighborhood}
              </span>
              <Separator pipe alwaysShow />
            </>
          )}
          <span className={cn(previewStatus?.cityState ? s.cityStatePreview : '')}>
            {cityLocalityRegion}
          </span>
          <Separator pipe alwaysShow />
          {t(`country:${countryCode}`)}
        </p>
      </div>
    </div>
  );
};

export default Title;
